import { useDeviceType } from '@cian/ui-kit';
import { NeedConsultation } from 'shared/components/NeedConsultation';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const NeedConsultationContainer: React.FC = () => {
  const device = useDeviceType();

  const { config } = useApplicationContext();

  const isVisible = config.get<boolean>('info-subsidized-mortgage-frontend.consultationBlock.Enabled') ?? true;

  if (!isVisible) {
    return null;
  }

  return <NeedConsultation device={device} />;
};
